/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

// Import Routes

import { Route as rootRoute } from './routes/__root'
import { Route as PublicRouteImport } from './routes/_public/route'
import { Route as AuthenticatedRouteImport } from './routes/_authenticated/route'
import { Route as AuthenticatedIndexImport } from './routes/_authenticated/index'
import { Route as PublicLoginImport } from './routes/_public/login'
import { Route as AuthenticatedPhotoModerationImport } from './routes/_authenticated/photo-moderation'
import { Route as AuthenticatedMorningDigestImport } from './routes/_authenticated/morning-digest'
import { Route as AuthenticatedUsersRouteImport } from './routes/_authenticated/users/route'
import { Route as AuthenticatedSourceChannelsRouteImport } from './routes/_authenticated/source-channels/route'
import { Route as AuthenticatedServicesRouteImport } from './routes/_authenticated/services/route'
import { Route as AuthenticatedServiceCategoriesRouteImport } from './routes/_authenticated/service-categories/route'
import { Route as AuthenticatedPromotionTasksRouteImport } from './routes/_authenticated/promotion-tasks/route'
import { Route as AuthenticatedPlacesRouteImport } from './routes/_authenticated/places/route'
import { Route as AuthenticatedPlaceCategoriesRouteImport } from './routes/_authenticated/place-categories/route'
import { Route as AuthenticatedPaymentProvidersRouteImport } from './routes/_authenticated/payment-providers/route'
import { Route as AuthenticatedOrganizerBlocksRouteImport } from './routes/_authenticated/organizer-blocks/route'
import { Route as AuthenticatedNewsRouteImport } from './routes/_authenticated/news/route'
import { Route as AuthenticatedMeetingTemplatesRouteImport } from './routes/_authenticated/meeting-templates/route'
import { Route as AuthenticatedImportQueueRouteImport } from './routes/_authenticated/import-queue/route'
import { Route as AuthenticatedExtractorConfigRouteImport } from './routes/_authenticated/extractor-config/route'
import { Route as AuthenticatedEventsRouteImport } from './routes/_authenticated/events/route'
import { Route as AuthenticatedEventCategoriesRouteImport } from './routes/_authenticated/event-categories/route'
import { Route as AuthenticatedCrmRouteImport } from './routes/_authenticated/crm/route'
import { Route as AuthenticatedCoinTransactionsRouteImport } from './routes/_authenticated/coin-transactions/route'
import { Route as AuthenticatedCitiesRouteImport } from './routes/_authenticated/cities/route'
import { Route as AuthenticatedUsersIndexImport } from './routes/_authenticated/users/index'
import { Route as AuthenticatedSourceChannelsIndexImport } from './routes/_authenticated/source-channels/index'
import { Route as AuthenticatedServicesIndexImport } from './routes/_authenticated/services/index'
import { Route as AuthenticatedServiceCategoriesIndexImport } from './routes/_authenticated/service-categories/index'
import { Route as AuthenticatedPromotionTasksIndexImport } from './routes/_authenticated/promotion-tasks/index'
import { Route as AuthenticatedPlacesIndexImport } from './routes/_authenticated/places/index'
import { Route as AuthenticatedPlaceCategoriesIndexImport } from './routes/_authenticated/place-categories/index'
import { Route as AuthenticatedPaymentProvidersIndexImport } from './routes/_authenticated/payment-providers/index'
import { Route as AuthenticatedOrganizerBlocksIndexImport } from './routes/_authenticated/organizer-blocks/index'
import { Route as AuthenticatedNewsIndexImport } from './routes/_authenticated/news/index'
import { Route as AuthenticatedMeetingTemplatesIndexImport } from './routes/_authenticated/meeting-templates/index'
import { Route as AuthenticatedImportQueueIndexImport } from './routes/_authenticated/import-queue/index'
import { Route as AuthenticatedExtractorConfigIndexImport } from './routes/_authenticated/extractor-config/index'
import { Route as AuthenticatedEventsIndexImport } from './routes/_authenticated/events/index'
import { Route as AuthenticatedEventCategoriesIndexImport } from './routes/_authenticated/event-categories/index'
import { Route as AuthenticatedCrmIndexImport } from './routes/_authenticated/crm/index'
import { Route as AuthenticatedCoinTransactionsIndexImport } from './routes/_authenticated/coin-transactions/index'
import { Route as AuthenticatedCitiesIndexImport } from './routes/_authenticated/cities/index'
import { Route as PublicAuthTelegramCallbackImport } from './routes/_public/auth/telegram-callback'
import { Route as AuthenticatedUsersUserIdImport } from './routes/_authenticated/users/$userId'
import { Route as AuthenticatedSourceChannelsNewImport } from './routes/_authenticated/source-channels/new'
import { Route as AuthenticatedSourceChannelsChannelIdImport } from './routes/_authenticated/source-channels/$channelId'
import { Route as AuthenticatedServicesServiceIdImport } from './routes/_authenticated/services/$serviceId'
import { Route as AuthenticatedServiceCategoriesNewImport } from './routes/_authenticated/service-categories/new'
import { Route as AuthenticatedServiceCategoriesCategoryIdImport } from './routes/_authenticated/service-categories/$categoryId'
import { Route as AuthenticatedPlacesNewImport } from './routes/_authenticated/places/new'
import { Route as AuthenticatedPlacesPlaceIdImport } from './routes/_authenticated/places/$placeId'
import { Route as AuthenticatedPlaceCategoriesNewImport } from './routes/_authenticated/place-categories/new'
import { Route as AuthenticatedPlaceCategoriesCategoryIdImport } from './routes/_authenticated/place-categories/$categoryId'
import { Route as AuthenticatedPaymentProvidersNewImport } from './routes/_authenticated/payment-providers/new'
import { Route as AuthenticatedPaymentProvidersProviderIdImport } from './routes/_authenticated/payment-providers/$providerId'
import { Route as AuthenticatedMeetingTemplatesNewImport } from './routes/_authenticated/meeting-templates/new'
import { Route as AuthenticatedMeetingTemplatesTemplateIdImport } from './routes/_authenticated/meeting-templates/$templateId'
import { Route as AuthenticatedImportQueueMessageIdImport } from './routes/_authenticated/import-queue/$messageId'
import { Route as AuthenticatedEventsNewImport } from './routes/_authenticated/events/new'
import { Route as AuthenticatedEventsEventIdImport } from './routes/_authenticated/events/$eventId'
import { Route as AuthenticatedEventCategoriesNewImport } from './routes/_authenticated/event-categories/new'
import { Route as AuthenticatedEventCategoriesCategoryIdImport } from './routes/_authenticated/event-categories/$categoryId'
import { Route as AuthenticatedCrmTelegramImport } from './routes/_authenticated/crm/telegram'
import { Route as AuthenticatedCrmInstagramImport } from './routes/_authenticated/crm/instagram'
import { Route as AuthenticatedCrmEventsImport } from './routes/_authenticated/crm/events'
import { Route as AuthenticatedCrmConversationsImport } from './routes/_authenticated/crm/conversations'
import { Route as AuthenticatedCitiesNewImport } from './routes/_authenticated/cities/new'
import { Route as AuthenticatedCitiesCityIdImport } from './routes/_authenticated/cities/$cityId'
import { Route as AuthenticatedUsersFakesIndexImport } from './routes/_authenticated/users/fakes/index'
import { Route as AuthenticatedUsersFakesNewImport } from './routes/_authenticated/users/fakes/new'
import { Route as AuthenticatedUsersFakesFakeIdImport } from './routes/_authenticated/users/fakes/$fakeId'

// Create/Update Routes

const PublicRouteRoute = PublicRouteImport.update({
  id: '/_public',
  getParentRoute: () => rootRoute,
} as any)

const AuthenticatedRouteRoute = AuthenticatedRouteImport.update({
  id: '/_authenticated',
  getParentRoute: () => rootRoute,
} as any)

const AuthenticatedIndexRoute = AuthenticatedIndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)

const PublicLoginRoute = PublicLoginImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => PublicRouteRoute,
} as any)

const AuthenticatedPhotoModerationRoute =
  AuthenticatedPhotoModerationImport.update({
    id: '/photo-moderation',
    path: '/photo-moderation',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)

const AuthenticatedMorningDigestRoute = AuthenticatedMorningDigestImport.update(
  {
    id: '/morning-digest',
    path: '/morning-digest',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any,
)

const AuthenticatedUsersRouteRoute = AuthenticatedUsersRouteImport.update({
  id: '/users',
  path: '/users',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)

const AuthenticatedSourceChannelsRouteRoute =
  AuthenticatedSourceChannelsRouteImport.update({
    id: '/source-channels',
    path: '/source-channels',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)

const AuthenticatedServicesRouteRoute = AuthenticatedServicesRouteImport.update(
  {
    id: '/services',
    path: '/services',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any,
)

const AuthenticatedServiceCategoriesRouteRoute =
  AuthenticatedServiceCategoriesRouteImport.update({
    id: '/service-categories',
    path: '/service-categories',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)

const AuthenticatedPromotionTasksRouteRoute =
  AuthenticatedPromotionTasksRouteImport.update({
    id: '/promotion-tasks',
    path: '/promotion-tasks',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)

const AuthenticatedPlacesRouteRoute = AuthenticatedPlacesRouteImport.update({
  id: '/places',
  path: '/places',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)

const AuthenticatedPlaceCategoriesRouteRoute =
  AuthenticatedPlaceCategoriesRouteImport.update({
    id: '/place-categories',
    path: '/place-categories',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)

const AuthenticatedPaymentProvidersRouteRoute =
  AuthenticatedPaymentProvidersRouteImport.update({
    id: '/payment-providers',
    path: '/payment-providers',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)

const AuthenticatedOrganizerBlocksRouteRoute =
  AuthenticatedOrganizerBlocksRouteImport.update({
    id: '/organizer-blocks',
    path: '/organizer-blocks',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)

const AuthenticatedNewsRouteRoute = AuthenticatedNewsRouteImport.update({
  id: '/news',
  path: '/news',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)

const AuthenticatedMeetingTemplatesRouteRoute =
  AuthenticatedMeetingTemplatesRouteImport.update({
    id: '/meeting-templates',
    path: '/meeting-templates',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)

const AuthenticatedImportQueueRouteRoute =
  AuthenticatedImportQueueRouteImport.update({
    id: '/import-queue',
    path: '/import-queue',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)

const AuthenticatedExtractorConfigRouteRoute =
  AuthenticatedExtractorConfigRouteImport.update({
    id: '/extractor-config',
    path: '/extractor-config',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)

const AuthenticatedEventsRouteRoute = AuthenticatedEventsRouteImport.update({
  id: '/events',
  path: '/events',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)

const AuthenticatedEventCategoriesRouteRoute =
  AuthenticatedEventCategoriesRouteImport.update({
    id: '/event-categories',
    path: '/event-categories',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)

const AuthenticatedCrmRouteRoute = AuthenticatedCrmRouteImport.update({
  id: '/crm',
  path: '/crm',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)

const AuthenticatedCoinTransactionsRouteRoute =
  AuthenticatedCoinTransactionsRouteImport.update({
    id: '/coin-transactions',
    path: '/coin-transactions',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)

const AuthenticatedCitiesRouteRoute = AuthenticatedCitiesRouteImport.update({
  id: '/cities',
  path: '/cities',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)

const AuthenticatedUsersIndexRoute = AuthenticatedUsersIndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthenticatedUsersRouteRoute,
} as any)

const AuthenticatedSourceChannelsIndexRoute =
  AuthenticatedSourceChannelsIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedSourceChannelsRouteRoute,
  } as any)

const AuthenticatedServicesIndexRoute = AuthenticatedServicesIndexImport.update(
  {
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedServicesRouteRoute,
  } as any,
)

const AuthenticatedServiceCategoriesIndexRoute =
  AuthenticatedServiceCategoriesIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedServiceCategoriesRouteRoute,
  } as any)

const AuthenticatedPromotionTasksIndexRoute =
  AuthenticatedPromotionTasksIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedPromotionTasksRouteRoute,
  } as any)

const AuthenticatedPlacesIndexRoute = AuthenticatedPlacesIndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthenticatedPlacesRouteRoute,
} as any)

const AuthenticatedPlaceCategoriesIndexRoute =
  AuthenticatedPlaceCategoriesIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedPlaceCategoriesRouteRoute,
  } as any)

const AuthenticatedPaymentProvidersIndexRoute =
  AuthenticatedPaymentProvidersIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedPaymentProvidersRouteRoute,
  } as any)

const AuthenticatedOrganizerBlocksIndexRoute =
  AuthenticatedOrganizerBlocksIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedOrganizerBlocksRouteRoute,
  } as any)

const AuthenticatedNewsIndexRoute = AuthenticatedNewsIndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthenticatedNewsRouteRoute,
} as any)

const AuthenticatedMeetingTemplatesIndexRoute =
  AuthenticatedMeetingTemplatesIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedMeetingTemplatesRouteRoute,
  } as any)

const AuthenticatedImportQueueIndexRoute =
  AuthenticatedImportQueueIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedImportQueueRouteRoute,
  } as any)

const AuthenticatedExtractorConfigIndexRoute =
  AuthenticatedExtractorConfigIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedExtractorConfigRouteRoute,
  } as any)

const AuthenticatedEventsIndexRoute = AuthenticatedEventsIndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthenticatedEventsRouteRoute,
} as any)

const AuthenticatedEventCategoriesIndexRoute =
  AuthenticatedEventCategoriesIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedEventCategoriesRouteRoute,
  } as any)

const AuthenticatedCrmIndexRoute = AuthenticatedCrmIndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthenticatedCrmRouteRoute,
} as any)

const AuthenticatedCoinTransactionsIndexRoute =
  AuthenticatedCoinTransactionsIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedCoinTransactionsRouteRoute,
  } as any)

const AuthenticatedCitiesIndexRoute = AuthenticatedCitiesIndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthenticatedCitiesRouteRoute,
} as any)

const PublicAuthTelegramCallbackRoute = PublicAuthTelegramCallbackImport.update(
  {
    id: '/auth/telegram-callback',
    path: '/auth/telegram-callback',
    getParentRoute: () => PublicRouteRoute,
  } as any,
)

const AuthenticatedUsersUserIdRoute = AuthenticatedUsersUserIdImport.update({
  id: '/$userId',
  path: '/$userId',
  getParentRoute: () => AuthenticatedUsersRouteRoute,
} as any)

const AuthenticatedSourceChannelsNewRoute =
  AuthenticatedSourceChannelsNewImport.update({
    id: '/new',
    path: '/new',
    getParentRoute: () => AuthenticatedSourceChannelsRouteRoute,
  } as any)

const AuthenticatedSourceChannelsChannelIdRoute =
  AuthenticatedSourceChannelsChannelIdImport.update({
    id: '/$channelId',
    path: '/$channelId',
    getParentRoute: () => AuthenticatedSourceChannelsRouteRoute,
  } as any)

const AuthenticatedServicesServiceIdRoute =
  AuthenticatedServicesServiceIdImport.update({
    id: '/$serviceId',
    path: '/$serviceId',
    getParentRoute: () => AuthenticatedServicesRouteRoute,
  } as any)

const AuthenticatedServiceCategoriesNewRoute =
  AuthenticatedServiceCategoriesNewImport.update({
    id: '/new',
    path: '/new',
    getParentRoute: () => AuthenticatedServiceCategoriesRouteRoute,
  } as any)

const AuthenticatedServiceCategoriesCategoryIdRoute =
  AuthenticatedServiceCategoriesCategoryIdImport.update({
    id: '/$categoryId',
    path: '/$categoryId',
    getParentRoute: () => AuthenticatedServiceCategoriesRouteRoute,
  } as any)

const AuthenticatedPlacesNewRoute = AuthenticatedPlacesNewImport.update({
  id: '/new',
  path: '/new',
  getParentRoute: () => AuthenticatedPlacesRouteRoute,
} as any)

const AuthenticatedPlacesPlaceIdRoute = AuthenticatedPlacesPlaceIdImport.update(
  {
    id: '/$placeId',
    path: '/$placeId',
    getParentRoute: () => AuthenticatedPlacesRouteRoute,
  } as any,
)

const AuthenticatedPlaceCategoriesNewRoute =
  AuthenticatedPlaceCategoriesNewImport.update({
    id: '/new',
    path: '/new',
    getParentRoute: () => AuthenticatedPlaceCategoriesRouteRoute,
  } as any)

const AuthenticatedPlaceCategoriesCategoryIdRoute =
  AuthenticatedPlaceCategoriesCategoryIdImport.update({
    id: '/$categoryId',
    path: '/$categoryId',
    getParentRoute: () => AuthenticatedPlaceCategoriesRouteRoute,
  } as any)

const AuthenticatedPaymentProvidersNewRoute =
  AuthenticatedPaymentProvidersNewImport.update({
    id: '/new',
    path: '/new',
    getParentRoute: () => AuthenticatedPaymentProvidersRouteRoute,
  } as any)

const AuthenticatedPaymentProvidersProviderIdRoute =
  AuthenticatedPaymentProvidersProviderIdImport.update({
    id: '/$providerId',
    path: '/$providerId',
    getParentRoute: () => AuthenticatedPaymentProvidersRouteRoute,
  } as any)

const AuthenticatedMeetingTemplatesNewRoute =
  AuthenticatedMeetingTemplatesNewImport.update({
    id: '/new',
    path: '/new',
    getParentRoute: () => AuthenticatedMeetingTemplatesRouteRoute,
  } as any)

const AuthenticatedMeetingTemplatesTemplateIdRoute =
  AuthenticatedMeetingTemplatesTemplateIdImport.update({
    id: '/$templateId',
    path: '/$templateId',
    getParentRoute: () => AuthenticatedMeetingTemplatesRouteRoute,
  } as any)

const AuthenticatedImportQueueMessageIdRoute =
  AuthenticatedImportQueueMessageIdImport.update({
    id: '/$messageId',
    path: '/$messageId',
    getParentRoute: () => AuthenticatedImportQueueRouteRoute,
  } as any)

const AuthenticatedEventsNewRoute = AuthenticatedEventsNewImport.update({
  id: '/new',
  path: '/new',
  getParentRoute: () => AuthenticatedEventsRouteRoute,
} as any)

const AuthenticatedEventsEventIdRoute = AuthenticatedEventsEventIdImport.update(
  {
    id: '/$eventId',
    path: '/$eventId',
    getParentRoute: () => AuthenticatedEventsRouteRoute,
  } as any,
)

const AuthenticatedEventCategoriesNewRoute =
  AuthenticatedEventCategoriesNewImport.update({
    id: '/new',
    path: '/new',
    getParentRoute: () => AuthenticatedEventCategoriesRouteRoute,
  } as any)

const AuthenticatedEventCategoriesCategoryIdRoute =
  AuthenticatedEventCategoriesCategoryIdImport.update({
    id: '/$categoryId',
    path: '/$categoryId',
    getParentRoute: () => AuthenticatedEventCategoriesRouteRoute,
  } as any)

const AuthenticatedCrmTelegramRoute = AuthenticatedCrmTelegramImport.update({
  id: '/telegram',
  path: '/telegram',
  getParentRoute: () => AuthenticatedCrmRouteRoute,
} as any)

const AuthenticatedCrmInstagramRoute = AuthenticatedCrmInstagramImport.update({
  id: '/instagram',
  path: '/instagram',
  getParentRoute: () => AuthenticatedCrmRouteRoute,
} as any)

const AuthenticatedCrmEventsRoute = AuthenticatedCrmEventsImport.update({
  id: '/events',
  path: '/events',
  getParentRoute: () => AuthenticatedCrmRouteRoute,
} as any)

const AuthenticatedCrmConversationsRoute =
  AuthenticatedCrmConversationsImport.update({
    id: '/conversations',
    path: '/conversations',
    getParentRoute: () => AuthenticatedCrmRouteRoute,
  } as any)

const AuthenticatedCitiesNewRoute = AuthenticatedCitiesNewImport.update({
  id: '/new',
  path: '/new',
  getParentRoute: () => AuthenticatedCitiesRouteRoute,
} as any)

const AuthenticatedCitiesCityIdRoute = AuthenticatedCitiesCityIdImport.update({
  id: '/$cityId',
  path: '/$cityId',
  getParentRoute: () => AuthenticatedCitiesRouteRoute,
} as any)

const AuthenticatedUsersFakesIndexRoute =
  AuthenticatedUsersFakesIndexImport.update({
    id: '/fakes/',
    path: '/fakes/',
    getParentRoute: () => AuthenticatedUsersRouteRoute,
  } as any)

const AuthenticatedUsersFakesNewRoute = AuthenticatedUsersFakesNewImport.update(
  {
    id: '/fakes/new',
    path: '/fakes/new',
    getParentRoute: () => AuthenticatedUsersRouteRoute,
  } as any,
)

const AuthenticatedUsersFakesFakeIdRoute =
  AuthenticatedUsersFakesFakeIdImport.update({
    id: '/fakes/$fakeId',
    path: '/fakes/$fakeId',
    getParentRoute: () => AuthenticatedUsersRouteRoute,
  } as any)

// Populate the FileRoutesByPath interface

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_authenticated': {
      id: '/_authenticated'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof AuthenticatedRouteImport
      parentRoute: typeof rootRoute
    }
    '/_public': {
      id: '/_public'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof PublicRouteImport
      parentRoute: typeof rootRoute
    }
    '/_authenticated/cities': {
      id: '/_authenticated/cities'
      path: '/cities'
      fullPath: '/cities'
      preLoaderRoute: typeof AuthenticatedCitiesRouteImport
      parentRoute: typeof AuthenticatedRouteImport
    }
    '/_authenticated/coin-transactions': {
      id: '/_authenticated/coin-transactions'
      path: '/coin-transactions'
      fullPath: '/coin-transactions'
      preLoaderRoute: typeof AuthenticatedCoinTransactionsRouteImport
      parentRoute: typeof AuthenticatedRouteImport
    }
    '/_authenticated/crm': {
      id: '/_authenticated/crm'
      path: '/crm'
      fullPath: '/crm'
      preLoaderRoute: typeof AuthenticatedCrmRouteImport
      parentRoute: typeof AuthenticatedRouteImport
    }
    '/_authenticated/event-categories': {
      id: '/_authenticated/event-categories'
      path: '/event-categories'
      fullPath: '/event-categories'
      preLoaderRoute: typeof AuthenticatedEventCategoriesRouteImport
      parentRoute: typeof AuthenticatedRouteImport
    }
    '/_authenticated/events': {
      id: '/_authenticated/events'
      path: '/events'
      fullPath: '/events'
      preLoaderRoute: typeof AuthenticatedEventsRouteImport
      parentRoute: typeof AuthenticatedRouteImport
    }
    '/_authenticated/extractor-config': {
      id: '/_authenticated/extractor-config'
      path: '/extractor-config'
      fullPath: '/extractor-config'
      preLoaderRoute: typeof AuthenticatedExtractorConfigRouteImport
      parentRoute: typeof AuthenticatedRouteImport
    }
    '/_authenticated/import-queue': {
      id: '/_authenticated/import-queue'
      path: '/import-queue'
      fullPath: '/import-queue'
      preLoaderRoute: typeof AuthenticatedImportQueueRouteImport
      parentRoute: typeof AuthenticatedRouteImport
    }
    '/_authenticated/meeting-templates': {
      id: '/_authenticated/meeting-templates'
      path: '/meeting-templates'
      fullPath: '/meeting-templates'
      preLoaderRoute: typeof AuthenticatedMeetingTemplatesRouteImport
      parentRoute: typeof AuthenticatedRouteImport
    }
    '/_authenticated/news': {
      id: '/_authenticated/news'
      path: '/news'
      fullPath: '/news'
      preLoaderRoute: typeof AuthenticatedNewsRouteImport
      parentRoute: typeof AuthenticatedRouteImport
    }
    '/_authenticated/organizer-blocks': {
      id: '/_authenticated/organizer-blocks'
      path: '/organizer-blocks'
      fullPath: '/organizer-blocks'
      preLoaderRoute: typeof AuthenticatedOrganizerBlocksRouteImport
      parentRoute: typeof AuthenticatedRouteImport
    }
    '/_authenticated/payment-providers': {
      id: '/_authenticated/payment-providers'
      path: '/payment-providers'
      fullPath: '/payment-providers'
      preLoaderRoute: typeof AuthenticatedPaymentProvidersRouteImport
      parentRoute: typeof AuthenticatedRouteImport
    }
    '/_authenticated/place-categories': {
      id: '/_authenticated/place-categories'
      path: '/place-categories'
      fullPath: '/place-categories'
      preLoaderRoute: typeof AuthenticatedPlaceCategoriesRouteImport
      parentRoute: typeof AuthenticatedRouteImport
    }
    '/_authenticated/places': {
      id: '/_authenticated/places'
      path: '/places'
      fullPath: '/places'
      preLoaderRoute: typeof AuthenticatedPlacesRouteImport
      parentRoute: typeof AuthenticatedRouteImport
    }
    '/_authenticated/promotion-tasks': {
      id: '/_authenticated/promotion-tasks'
      path: '/promotion-tasks'
      fullPath: '/promotion-tasks'
      preLoaderRoute: typeof AuthenticatedPromotionTasksRouteImport
      parentRoute: typeof AuthenticatedRouteImport
    }
    '/_authenticated/service-categories': {
      id: '/_authenticated/service-categories'
      path: '/service-categories'
      fullPath: '/service-categories'
      preLoaderRoute: typeof AuthenticatedServiceCategoriesRouteImport
      parentRoute: typeof AuthenticatedRouteImport
    }
    '/_authenticated/services': {
      id: '/_authenticated/services'
      path: '/services'
      fullPath: '/services'
      preLoaderRoute: typeof AuthenticatedServicesRouteImport
      parentRoute: typeof AuthenticatedRouteImport
    }
    '/_authenticated/source-channels': {
      id: '/_authenticated/source-channels'
      path: '/source-channels'
      fullPath: '/source-channels'
      preLoaderRoute: typeof AuthenticatedSourceChannelsRouteImport
      parentRoute: typeof AuthenticatedRouteImport
    }
    '/_authenticated/users': {
      id: '/_authenticated/users'
      path: '/users'
      fullPath: '/users'
      preLoaderRoute: typeof AuthenticatedUsersRouteImport
      parentRoute: typeof AuthenticatedRouteImport
    }
    '/_authenticated/morning-digest': {
      id: '/_authenticated/morning-digest'
      path: '/morning-digest'
      fullPath: '/morning-digest'
      preLoaderRoute: typeof AuthenticatedMorningDigestImport
      parentRoute: typeof AuthenticatedRouteImport
    }
    '/_authenticated/photo-moderation': {
      id: '/_authenticated/photo-moderation'
      path: '/photo-moderation'
      fullPath: '/photo-moderation'
      preLoaderRoute: typeof AuthenticatedPhotoModerationImport
      parentRoute: typeof AuthenticatedRouteImport
    }
    '/_public/login': {
      id: '/_public/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof PublicLoginImport
      parentRoute: typeof PublicRouteImport
    }
    '/_authenticated/': {
      id: '/_authenticated/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedIndexImport
      parentRoute: typeof AuthenticatedRouteImport
    }
    '/_authenticated/cities/$cityId': {
      id: '/_authenticated/cities/$cityId'
      path: '/$cityId'
      fullPath: '/cities/$cityId'
      preLoaderRoute: typeof AuthenticatedCitiesCityIdImport
      parentRoute: typeof AuthenticatedCitiesRouteImport
    }
    '/_authenticated/cities/new': {
      id: '/_authenticated/cities/new'
      path: '/new'
      fullPath: '/cities/new'
      preLoaderRoute: typeof AuthenticatedCitiesNewImport
      parentRoute: typeof AuthenticatedCitiesRouteImport
    }
    '/_authenticated/crm/conversations': {
      id: '/_authenticated/crm/conversations'
      path: '/conversations'
      fullPath: '/crm/conversations'
      preLoaderRoute: typeof AuthenticatedCrmConversationsImport
      parentRoute: typeof AuthenticatedCrmRouteImport
    }
    '/_authenticated/crm/events': {
      id: '/_authenticated/crm/events'
      path: '/events'
      fullPath: '/crm/events'
      preLoaderRoute: typeof AuthenticatedCrmEventsImport
      parentRoute: typeof AuthenticatedCrmRouteImport
    }
    '/_authenticated/crm/instagram': {
      id: '/_authenticated/crm/instagram'
      path: '/instagram'
      fullPath: '/crm/instagram'
      preLoaderRoute: typeof AuthenticatedCrmInstagramImport
      parentRoute: typeof AuthenticatedCrmRouteImport
    }
    '/_authenticated/crm/telegram': {
      id: '/_authenticated/crm/telegram'
      path: '/telegram'
      fullPath: '/crm/telegram'
      preLoaderRoute: typeof AuthenticatedCrmTelegramImport
      parentRoute: typeof AuthenticatedCrmRouteImport
    }
    '/_authenticated/event-categories/$categoryId': {
      id: '/_authenticated/event-categories/$categoryId'
      path: '/$categoryId'
      fullPath: '/event-categories/$categoryId'
      preLoaderRoute: typeof AuthenticatedEventCategoriesCategoryIdImport
      parentRoute: typeof AuthenticatedEventCategoriesRouteImport
    }
    '/_authenticated/event-categories/new': {
      id: '/_authenticated/event-categories/new'
      path: '/new'
      fullPath: '/event-categories/new'
      preLoaderRoute: typeof AuthenticatedEventCategoriesNewImport
      parentRoute: typeof AuthenticatedEventCategoriesRouteImport
    }
    '/_authenticated/events/$eventId': {
      id: '/_authenticated/events/$eventId'
      path: '/$eventId'
      fullPath: '/events/$eventId'
      preLoaderRoute: typeof AuthenticatedEventsEventIdImport
      parentRoute: typeof AuthenticatedEventsRouteImport
    }
    '/_authenticated/events/new': {
      id: '/_authenticated/events/new'
      path: '/new'
      fullPath: '/events/new'
      preLoaderRoute: typeof AuthenticatedEventsNewImport
      parentRoute: typeof AuthenticatedEventsRouteImport
    }
    '/_authenticated/import-queue/$messageId': {
      id: '/_authenticated/import-queue/$messageId'
      path: '/$messageId'
      fullPath: '/import-queue/$messageId'
      preLoaderRoute: typeof AuthenticatedImportQueueMessageIdImport
      parentRoute: typeof AuthenticatedImportQueueRouteImport
    }
    '/_authenticated/meeting-templates/$templateId': {
      id: '/_authenticated/meeting-templates/$templateId'
      path: '/$templateId'
      fullPath: '/meeting-templates/$templateId'
      preLoaderRoute: typeof AuthenticatedMeetingTemplatesTemplateIdImport
      parentRoute: typeof AuthenticatedMeetingTemplatesRouteImport
    }
    '/_authenticated/meeting-templates/new': {
      id: '/_authenticated/meeting-templates/new'
      path: '/new'
      fullPath: '/meeting-templates/new'
      preLoaderRoute: typeof AuthenticatedMeetingTemplatesNewImport
      parentRoute: typeof AuthenticatedMeetingTemplatesRouteImport
    }
    '/_authenticated/payment-providers/$providerId': {
      id: '/_authenticated/payment-providers/$providerId'
      path: '/$providerId'
      fullPath: '/payment-providers/$providerId'
      preLoaderRoute: typeof AuthenticatedPaymentProvidersProviderIdImport
      parentRoute: typeof AuthenticatedPaymentProvidersRouteImport
    }
    '/_authenticated/payment-providers/new': {
      id: '/_authenticated/payment-providers/new'
      path: '/new'
      fullPath: '/payment-providers/new'
      preLoaderRoute: typeof AuthenticatedPaymentProvidersNewImport
      parentRoute: typeof AuthenticatedPaymentProvidersRouteImport
    }
    '/_authenticated/place-categories/$categoryId': {
      id: '/_authenticated/place-categories/$categoryId'
      path: '/$categoryId'
      fullPath: '/place-categories/$categoryId'
      preLoaderRoute: typeof AuthenticatedPlaceCategoriesCategoryIdImport
      parentRoute: typeof AuthenticatedPlaceCategoriesRouteImport
    }
    '/_authenticated/place-categories/new': {
      id: '/_authenticated/place-categories/new'
      path: '/new'
      fullPath: '/place-categories/new'
      preLoaderRoute: typeof AuthenticatedPlaceCategoriesNewImport
      parentRoute: typeof AuthenticatedPlaceCategoriesRouteImport
    }
    '/_authenticated/places/$placeId': {
      id: '/_authenticated/places/$placeId'
      path: '/$placeId'
      fullPath: '/places/$placeId'
      preLoaderRoute: typeof AuthenticatedPlacesPlaceIdImport
      parentRoute: typeof AuthenticatedPlacesRouteImport
    }
    '/_authenticated/places/new': {
      id: '/_authenticated/places/new'
      path: '/new'
      fullPath: '/places/new'
      preLoaderRoute: typeof AuthenticatedPlacesNewImport
      parentRoute: typeof AuthenticatedPlacesRouteImport
    }
    '/_authenticated/service-categories/$categoryId': {
      id: '/_authenticated/service-categories/$categoryId'
      path: '/$categoryId'
      fullPath: '/service-categories/$categoryId'
      preLoaderRoute: typeof AuthenticatedServiceCategoriesCategoryIdImport
      parentRoute: typeof AuthenticatedServiceCategoriesRouteImport
    }
    '/_authenticated/service-categories/new': {
      id: '/_authenticated/service-categories/new'
      path: '/new'
      fullPath: '/service-categories/new'
      preLoaderRoute: typeof AuthenticatedServiceCategoriesNewImport
      parentRoute: typeof AuthenticatedServiceCategoriesRouteImport
    }
    '/_authenticated/services/$serviceId': {
      id: '/_authenticated/services/$serviceId'
      path: '/$serviceId'
      fullPath: '/services/$serviceId'
      preLoaderRoute: typeof AuthenticatedServicesServiceIdImport
      parentRoute: typeof AuthenticatedServicesRouteImport
    }
    '/_authenticated/source-channels/$channelId': {
      id: '/_authenticated/source-channels/$channelId'
      path: '/$channelId'
      fullPath: '/source-channels/$channelId'
      preLoaderRoute: typeof AuthenticatedSourceChannelsChannelIdImport
      parentRoute: typeof AuthenticatedSourceChannelsRouteImport
    }
    '/_authenticated/source-channels/new': {
      id: '/_authenticated/source-channels/new'
      path: '/new'
      fullPath: '/source-channels/new'
      preLoaderRoute: typeof AuthenticatedSourceChannelsNewImport
      parentRoute: typeof AuthenticatedSourceChannelsRouteImport
    }
    '/_authenticated/users/$userId': {
      id: '/_authenticated/users/$userId'
      path: '/$userId'
      fullPath: '/users/$userId'
      preLoaderRoute: typeof AuthenticatedUsersUserIdImport
      parentRoute: typeof AuthenticatedUsersRouteImport
    }
    '/_public/auth/telegram-callback': {
      id: '/_public/auth/telegram-callback'
      path: '/auth/telegram-callback'
      fullPath: '/auth/telegram-callback'
      preLoaderRoute: typeof PublicAuthTelegramCallbackImport
      parentRoute: typeof PublicRouteImport
    }
    '/_authenticated/cities/': {
      id: '/_authenticated/cities/'
      path: '/'
      fullPath: '/cities/'
      preLoaderRoute: typeof AuthenticatedCitiesIndexImport
      parentRoute: typeof AuthenticatedCitiesRouteImport
    }
    '/_authenticated/coin-transactions/': {
      id: '/_authenticated/coin-transactions/'
      path: '/'
      fullPath: '/coin-transactions/'
      preLoaderRoute: typeof AuthenticatedCoinTransactionsIndexImport
      parentRoute: typeof AuthenticatedCoinTransactionsRouteImport
    }
    '/_authenticated/crm/': {
      id: '/_authenticated/crm/'
      path: '/'
      fullPath: '/crm/'
      preLoaderRoute: typeof AuthenticatedCrmIndexImport
      parentRoute: typeof AuthenticatedCrmRouteImport
    }
    '/_authenticated/event-categories/': {
      id: '/_authenticated/event-categories/'
      path: '/'
      fullPath: '/event-categories/'
      preLoaderRoute: typeof AuthenticatedEventCategoriesIndexImport
      parentRoute: typeof AuthenticatedEventCategoriesRouteImport
    }
    '/_authenticated/events/': {
      id: '/_authenticated/events/'
      path: '/'
      fullPath: '/events/'
      preLoaderRoute: typeof AuthenticatedEventsIndexImport
      parentRoute: typeof AuthenticatedEventsRouteImport
    }
    '/_authenticated/extractor-config/': {
      id: '/_authenticated/extractor-config/'
      path: '/'
      fullPath: '/extractor-config/'
      preLoaderRoute: typeof AuthenticatedExtractorConfigIndexImport
      parentRoute: typeof AuthenticatedExtractorConfigRouteImport
    }
    '/_authenticated/import-queue/': {
      id: '/_authenticated/import-queue/'
      path: '/'
      fullPath: '/import-queue/'
      preLoaderRoute: typeof AuthenticatedImportQueueIndexImport
      parentRoute: typeof AuthenticatedImportQueueRouteImport
    }
    '/_authenticated/meeting-templates/': {
      id: '/_authenticated/meeting-templates/'
      path: '/'
      fullPath: '/meeting-templates/'
      preLoaderRoute: typeof AuthenticatedMeetingTemplatesIndexImport
      parentRoute: typeof AuthenticatedMeetingTemplatesRouteImport
    }
    '/_authenticated/news/': {
      id: '/_authenticated/news/'
      path: '/'
      fullPath: '/news/'
      preLoaderRoute: typeof AuthenticatedNewsIndexImport
      parentRoute: typeof AuthenticatedNewsRouteImport
    }
    '/_authenticated/organizer-blocks/': {
      id: '/_authenticated/organizer-blocks/'
      path: '/'
      fullPath: '/organizer-blocks/'
      preLoaderRoute: typeof AuthenticatedOrganizerBlocksIndexImport
      parentRoute: typeof AuthenticatedOrganizerBlocksRouteImport
    }
    '/_authenticated/payment-providers/': {
      id: '/_authenticated/payment-providers/'
      path: '/'
      fullPath: '/payment-providers/'
      preLoaderRoute: typeof AuthenticatedPaymentProvidersIndexImport
      parentRoute: typeof AuthenticatedPaymentProvidersRouteImport
    }
    '/_authenticated/place-categories/': {
      id: '/_authenticated/place-categories/'
      path: '/'
      fullPath: '/place-categories/'
      preLoaderRoute: typeof AuthenticatedPlaceCategoriesIndexImport
      parentRoute: typeof AuthenticatedPlaceCategoriesRouteImport
    }
    '/_authenticated/places/': {
      id: '/_authenticated/places/'
      path: '/'
      fullPath: '/places/'
      preLoaderRoute: typeof AuthenticatedPlacesIndexImport
      parentRoute: typeof AuthenticatedPlacesRouteImport
    }
    '/_authenticated/promotion-tasks/': {
      id: '/_authenticated/promotion-tasks/'
      path: '/'
      fullPath: '/promotion-tasks/'
      preLoaderRoute: typeof AuthenticatedPromotionTasksIndexImport
      parentRoute: typeof AuthenticatedPromotionTasksRouteImport
    }
    '/_authenticated/service-categories/': {
      id: '/_authenticated/service-categories/'
      path: '/'
      fullPath: '/service-categories/'
      preLoaderRoute: typeof AuthenticatedServiceCategoriesIndexImport
      parentRoute: typeof AuthenticatedServiceCategoriesRouteImport
    }
    '/_authenticated/services/': {
      id: '/_authenticated/services/'
      path: '/'
      fullPath: '/services/'
      preLoaderRoute: typeof AuthenticatedServicesIndexImport
      parentRoute: typeof AuthenticatedServicesRouteImport
    }
    '/_authenticated/source-channels/': {
      id: '/_authenticated/source-channels/'
      path: '/'
      fullPath: '/source-channels/'
      preLoaderRoute: typeof AuthenticatedSourceChannelsIndexImport
      parentRoute: typeof AuthenticatedSourceChannelsRouteImport
    }
    '/_authenticated/users/': {
      id: '/_authenticated/users/'
      path: '/'
      fullPath: '/users/'
      preLoaderRoute: typeof AuthenticatedUsersIndexImport
      parentRoute: typeof AuthenticatedUsersRouteImport
    }
    '/_authenticated/users/fakes/$fakeId': {
      id: '/_authenticated/users/fakes/$fakeId'
      path: '/fakes/$fakeId'
      fullPath: '/users/fakes/$fakeId'
      preLoaderRoute: typeof AuthenticatedUsersFakesFakeIdImport
      parentRoute: typeof AuthenticatedUsersRouteImport
    }
    '/_authenticated/users/fakes/new': {
      id: '/_authenticated/users/fakes/new'
      path: '/fakes/new'
      fullPath: '/users/fakes/new'
      preLoaderRoute: typeof AuthenticatedUsersFakesNewImport
      parentRoute: typeof AuthenticatedUsersRouteImport
    }
    '/_authenticated/users/fakes/': {
      id: '/_authenticated/users/fakes/'
      path: '/fakes'
      fullPath: '/users/fakes'
      preLoaderRoute: typeof AuthenticatedUsersFakesIndexImport
      parentRoute: typeof AuthenticatedUsersRouteImport
    }
  }
}

// Create and export the route tree

interface AuthenticatedCitiesRouteRouteChildren {
  AuthenticatedCitiesCityIdRoute: typeof AuthenticatedCitiesCityIdRoute
  AuthenticatedCitiesNewRoute: typeof AuthenticatedCitiesNewRoute
  AuthenticatedCitiesIndexRoute: typeof AuthenticatedCitiesIndexRoute
}

const AuthenticatedCitiesRouteRouteChildren: AuthenticatedCitiesRouteRouteChildren =
  {
    AuthenticatedCitiesCityIdRoute: AuthenticatedCitiesCityIdRoute,
    AuthenticatedCitiesNewRoute: AuthenticatedCitiesNewRoute,
    AuthenticatedCitiesIndexRoute: AuthenticatedCitiesIndexRoute,
  }

const AuthenticatedCitiesRouteRouteWithChildren =
  AuthenticatedCitiesRouteRoute._addFileChildren(
    AuthenticatedCitiesRouteRouteChildren,
  )

interface AuthenticatedCoinTransactionsRouteRouteChildren {
  AuthenticatedCoinTransactionsIndexRoute: typeof AuthenticatedCoinTransactionsIndexRoute
}

const AuthenticatedCoinTransactionsRouteRouteChildren: AuthenticatedCoinTransactionsRouteRouteChildren =
  {
    AuthenticatedCoinTransactionsIndexRoute:
      AuthenticatedCoinTransactionsIndexRoute,
  }

const AuthenticatedCoinTransactionsRouteRouteWithChildren =
  AuthenticatedCoinTransactionsRouteRoute._addFileChildren(
    AuthenticatedCoinTransactionsRouteRouteChildren,
  )

interface AuthenticatedCrmRouteRouteChildren {
  AuthenticatedCrmConversationsRoute: typeof AuthenticatedCrmConversationsRoute
  AuthenticatedCrmEventsRoute: typeof AuthenticatedCrmEventsRoute
  AuthenticatedCrmInstagramRoute: typeof AuthenticatedCrmInstagramRoute
  AuthenticatedCrmTelegramRoute: typeof AuthenticatedCrmTelegramRoute
  AuthenticatedCrmIndexRoute: typeof AuthenticatedCrmIndexRoute
}

const AuthenticatedCrmRouteRouteChildren: AuthenticatedCrmRouteRouteChildren = {
  AuthenticatedCrmConversationsRoute: AuthenticatedCrmConversationsRoute,
  AuthenticatedCrmEventsRoute: AuthenticatedCrmEventsRoute,
  AuthenticatedCrmInstagramRoute: AuthenticatedCrmInstagramRoute,
  AuthenticatedCrmTelegramRoute: AuthenticatedCrmTelegramRoute,
  AuthenticatedCrmIndexRoute: AuthenticatedCrmIndexRoute,
}

const AuthenticatedCrmRouteRouteWithChildren =
  AuthenticatedCrmRouteRoute._addFileChildren(
    AuthenticatedCrmRouteRouteChildren,
  )

interface AuthenticatedEventCategoriesRouteRouteChildren {
  AuthenticatedEventCategoriesCategoryIdRoute: typeof AuthenticatedEventCategoriesCategoryIdRoute
  AuthenticatedEventCategoriesNewRoute: typeof AuthenticatedEventCategoriesNewRoute
  AuthenticatedEventCategoriesIndexRoute: typeof AuthenticatedEventCategoriesIndexRoute
}

const AuthenticatedEventCategoriesRouteRouteChildren: AuthenticatedEventCategoriesRouteRouteChildren =
  {
    AuthenticatedEventCategoriesCategoryIdRoute:
      AuthenticatedEventCategoriesCategoryIdRoute,
    AuthenticatedEventCategoriesNewRoute: AuthenticatedEventCategoriesNewRoute,
    AuthenticatedEventCategoriesIndexRoute:
      AuthenticatedEventCategoriesIndexRoute,
  }

const AuthenticatedEventCategoriesRouteRouteWithChildren =
  AuthenticatedEventCategoriesRouteRoute._addFileChildren(
    AuthenticatedEventCategoriesRouteRouteChildren,
  )

interface AuthenticatedEventsRouteRouteChildren {
  AuthenticatedEventsEventIdRoute: typeof AuthenticatedEventsEventIdRoute
  AuthenticatedEventsNewRoute: typeof AuthenticatedEventsNewRoute
  AuthenticatedEventsIndexRoute: typeof AuthenticatedEventsIndexRoute
}

const AuthenticatedEventsRouteRouteChildren: AuthenticatedEventsRouteRouteChildren =
  {
    AuthenticatedEventsEventIdRoute: AuthenticatedEventsEventIdRoute,
    AuthenticatedEventsNewRoute: AuthenticatedEventsNewRoute,
    AuthenticatedEventsIndexRoute: AuthenticatedEventsIndexRoute,
  }

const AuthenticatedEventsRouteRouteWithChildren =
  AuthenticatedEventsRouteRoute._addFileChildren(
    AuthenticatedEventsRouteRouteChildren,
  )

interface AuthenticatedExtractorConfigRouteRouteChildren {
  AuthenticatedExtractorConfigIndexRoute: typeof AuthenticatedExtractorConfigIndexRoute
}

const AuthenticatedExtractorConfigRouteRouteChildren: AuthenticatedExtractorConfigRouteRouteChildren =
  {
    AuthenticatedExtractorConfigIndexRoute:
      AuthenticatedExtractorConfigIndexRoute,
  }

const AuthenticatedExtractorConfigRouteRouteWithChildren =
  AuthenticatedExtractorConfigRouteRoute._addFileChildren(
    AuthenticatedExtractorConfigRouteRouteChildren,
  )

interface AuthenticatedImportQueueRouteRouteChildren {
  AuthenticatedImportQueueMessageIdRoute: typeof AuthenticatedImportQueueMessageIdRoute
  AuthenticatedImportQueueIndexRoute: typeof AuthenticatedImportQueueIndexRoute
}

const AuthenticatedImportQueueRouteRouteChildren: AuthenticatedImportQueueRouteRouteChildren =
  {
    AuthenticatedImportQueueMessageIdRoute:
      AuthenticatedImportQueueMessageIdRoute,
    AuthenticatedImportQueueIndexRoute: AuthenticatedImportQueueIndexRoute,
  }

const AuthenticatedImportQueueRouteRouteWithChildren =
  AuthenticatedImportQueueRouteRoute._addFileChildren(
    AuthenticatedImportQueueRouteRouteChildren,
  )

interface AuthenticatedMeetingTemplatesRouteRouteChildren {
  AuthenticatedMeetingTemplatesTemplateIdRoute: typeof AuthenticatedMeetingTemplatesTemplateIdRoute
  AuthenticatedMeetingTemplatesNewRoute: typeof AuthenticatedMeetingTemplatesNewRoute
  AuthenticatedMeetingTemplatesIndexRoute: typeof AuthenticatedMeetingTemplatesIndexRoute
}

const AuthenticatedMeetingTemplatesRouteRouteChildren: AuthenticatedMeetingTemplatesRouteRouteChildren =
  {
    AuthenticatedMeetingTemplatesTemplateIdRoute:
      AuthenticatedMeetingTemplatesTemplateIdRoute,
    AuthenticatedMeetingTemplatesNewRoute:
      AuthenticatedMeetingTemplatesNewRoute,
    AuthenticatedMeetingTemplatesIndexRoute:
      AuthenticatedMeetingTemplatesIndexRoute,
  }

const AuthenticatedMeetingTemplatesRouteRouteWithChildren =
  AuthenticatedMeetingTemplatesRouteRoute._addFileChildren(
    AuthenticatedMeetingTemplatesRouteRouteChildren,
  )

interface AuthenticatedNewsRouteRouteChildren {
  AuthenticatedNewsIndexRoute: typeof AuthenticatedNewsIndexRoute
}

const AuthenticatedNewsRouteRouteChildren: AuthenticatedNewsRouteRouteChildren =
  {
    AuthenticatedNewsIndexRoute: AuthenticatedNewsIndexRoute,
  }

const AuthenticatedNewsRouteRouteWithChildren =
  AuthenticatedNewsRouteRoute._addFileChildren(
    AuthenticatedNewsRouteRouteChildren,
  )

interface AuthenticatedOrganizerBlocksRouteRouteChildren {
  AuthenticatedOrganizerBlocksIndexRoute: typeof AuthenticatedOrganizerBlocksIndexRoute
}

const AuthenticatedOrganizerBlocksRouteRouteChildren: AuthenticatedOrganizerBlocksRouteRouteChildren =
  {
    AuthenticatedOrganizerBlocksIndexRoute:
      AuthenticatedOrganizerBlocksIndexRoute,
  }

const AuthenticatedOrganizerBlocksRouteRouteWithChildren =
  AuthenticatedOrganizerBlocksRouteRoute._addFileChildren(
    AuthenticatedOrganizerBlocksRouteRouteChildren,
  )

interface AuthenticatedPaymentProvidersRouteRouteChildren {
  AuthenticatedPaymentProvidersProviderIdRoute: typeof AuthenticatedPaymentProvidersProviderIdRoute
  AuthenticatedPaymentProvidersNewRoute: typeof AuthenticatedPaymentProvidersNewRoute
  AuthenticatedPaymentProvidersIndexRoute: typeof AuthenticatedPaymentProvidersIndexRoute
}

const AuthenticatedPaymentProvidersRouteRouteChildren: AuthenticatedPaymentProvidersRouteRouteChildren =
  {
    AuthenticatedPaymentProvidersProviderIdRoute:
      AuthenticatedPaymentProvidersProviderIdRoute,
    AuthenticatedPaymentProvidersNewRoute:
      AuthenticatedPaymentProvidersNewRoute,
    AuthenticatedPaymentProvidersIndexRoute:
      AuthenticatedPaymentProvidersIndexRoute,
  }

const AuthenticatedPaymentProvidersRouteRouteWithChildren =
  AuthenticatedPaymentProvidersRouteRoute._addFileChildren(
    AuthenticatedPaymentProvidersRouteRouteChildren,
  )

interface AuthenticatedPlaceCategoriesRouteRouteChildren {
  AuthenticatedPlaceCategoriesCategoryIdRoute: typeof AuthenticatedPlaceCategoriesCategoryIdRoute
  AuthenticatedPlaceCategoriesNewRoute: typeof AuthenticatedPlaceCategoriesNewRoute
  AuthenticatedPlaceCategoriesIndexRoute: typeof AuthenticatedPlaceCategoriesIndexRoute
}

const AuthenticatedPlaceCategoriesRouteRouteChildren: AuthenticatedPlaceCategoriesRouteRouteChildren =
  {
    AuthenticatedPlaceCategoriesCategoryIdRoute:
      AuthenticatedPlaceCategoriesCategoryIdRoute,
    AuthenticatedPlaceCategoriesNewRoute: AuthenticatedPlaceCategoriesNewRoute,
    AuthenticatedPlaceCategoriesIndexRoute:
      AuthenticatedPlaceCategoriesIndexRoute,
  }

const AuthenticatedPlaceCategoriesRouteRouteWithChildren =
  AuthenticatedPlaceCategoriesRouteRoute._addFileChildren(
    AuthenticatedPlaceCategoriesRouteRouteChildren,
  )

interface AuthenticatedPlacesRouteRouteChildren {
  AuthenticatedPlacesPlaceIdRoute: typeof AuthenticatedPlacesPlaceIdRoute
  AuthenticatedPlacesNewRoute: typeof AuthenticatedPlacesNewRoute
  AuthenticatedPlacesIndexRoute: typeof AuthenticatedPlacesIndexRoute
}

const AuthenticatedPlacesRouteRouteChildren: AuthenticatedPlacesRouteRouteChildren =
  {
    AuthenticatedPlacesPlaceIdRoute: AuthenticatedPlacesPlaceIdRoute,
    AuthenticatedPlacesNewRoute: AuthenticatedPlacesNewRoute,
    AuthenticatedPlacesIndexRoute: AuthenticatedPlacesIndexRoute,
  }

const AuthenticatedPlacesRouteRouteWithChildren =
  AuthenticatedPlacesRouteRoute._addFileChildren(
    AuthenticatedPlacesRouteRouteChildren,
  )

interface AuthenticatedPromotionTasksRouteRouteChildren {
  AuthenticatedPromotionTasksIndexRoute: typeof AuthenticatedPromotionTasksIndexRoute
}

const AuthenticatedPromotionTasksRouteRouteChildren: AuthenticatedPromotionTasksRouteRouteChildren =
  {
    AuthenticatedPromotionTasksIndexRoute:
      AuthenticatedPromotionTasksIndexRoute,
  }

const AuthenticatedPromotionTasksRouteRouteWithChildren =
  AuthenticatedPromotionTasksRouteRoute._addFileChildren(
    AuthenticatedPromotionTasksRouteRouteChildren,
  )

interface AuthenticatedServiceCategoriesRouteRouteChildren {
  AuthenticatedServiceCategoriesCategoryIdRoute: typeof AuthenticatedServiceCategoriesCategoryIdRoute
  AuthenticatedServiceCategoriesNewRoute: typeof AuthenticatedServiceCategoriesNewRoute
  AuthenticatedServiceCategoriesIndexRoute: typeof AuthenticatedServiceCategoriesIndexRoute
}

const AuthenticatedServiceCategoriesRouteRouteChildren: AuthenticatedServiceCategoriesRouteRouteChildren =
  {
    AuthenticatedServiceCategoriesCategoryIdRoute:
      AuthenticatedServiceCategoriesCategoryIdRoute,
    AuthenticatedServiceCategoriesNewRoute:
      AuthenticatedServiceCategoriesNewRoute,
    AuthenticatedServiceCategoriesIndexRoute:
      AuthenticatedServiceCategoriesIndexRoute,
  }

const AuthenticatedServiceCategoriesRouteRouteWithChildren =
  AuthenticatedServiceCategoriesRouteRoute._addFileChildren(
    AuthenticatedServiceCategoriesRouteRouteChildren,
  )

interface AuthenticatedServicesRouteRouteChildren {
  AuthenticatedServicesServiceIdRoute: typeof AuthenticatedServicesServiceIdRoute
  AuthenticatedServicesIndexRoute: typeof AuthenticatedServicesIndexRoute
}

const AuthenticatedServicesRouteRouteChildren: AuthenticatedServicesRouteRouteChildren =
  {
    AuthenticatedServicesServiceIdRoute: AuthenticatedServicesServiceIdRoute,
    AuthenticatedServicesIndexRoute: AuthenticatedServicesIndexRoute,
  }

const AuthenticatedServicesRouteRouteWithChildren =
  AuthenticatedServicesRouteRoute._addFileChildren(
    AuthenticatedServicesRouteRouteChildren,
  )

interface AuthenticatedSourceChannelsRouteRouteChildren {
  AuthenticatedSourceChannelsChannelIdRoute: typeof AuthenticatedSourceChannelsChannelIdRoute
  AuthenticatedSourceChannelsNewRoute: typeof AuthenticatedSourceChannelsNewRoute
  AuthenticatedSourceChannelsIndexRoute: typeof AuthenticatedSourceChannelsIndexRoute
}

const AuthenticatedSourceChannelsRouteRouteChildren: AuthenticatedSourceChannelsRouteRouteChildren =
  {
    AuthenticatedSourceChannelsChannelIdRoute:
      AuthenticatedSourceChannelsChannelIdRoute,
    AuthenticatedSourceChannelsNewRoute: AuthenticatedSourceChannelsNewRoute,
    AuthenticatedSourceChannelsIndexRoute:
      AuthenticatedSourceChannelsIndexRoute,
  }

const AuthenticatedSourceChannelsRouteRouteWithChildren =
  AuthenticatedSourceChannelsRouteRoute._addFileChildren(
    AuthenticatedSourceChannelsRouteRouteChildren,
  )

interface AuthenticatedUsersRouteRouteChildren {
  AuthenticatedUsersUserIdRoute: typeof AuthenticatedUsersUserIdRoute
  AuthenticatedUsersIndexRoute: typeof AuthenticatedUsersIndexRoute
  AuthenticatedUsersFakesFakeIdRoute: typeof AuthenticatedUsersFakesFakeIdRoute
  AuthenticatedUsersFakesNewRoute: typeof AuthenticatedUsersFakesNewRoute
  AuthenticatedUsersFakesIndexRoute: typeof AuthenticatedUsersFakesIndexRoute
}

const AuthenticatedUsersRouteRouteChildren: AuthenticatedUsersRouteRouteChildren =
  {
    AuthenticatedUsersUserIdRoute: AuthenticatedUsersUserIdRoute,
    AuthenticatedUsersIndexRoute: AuthenticatedUsersIndexRoute,
    AuthenticatedUsersFakesFakeIdRoute: AuthenticatedUsersFakesFakeIdRoute,
    AuthenticatedUsersFakesNewRoute: AuthenticatedUsersFakesNewRoute,
    AuthenticatedUsersFakesIndexRoute: AuthenticatedUsersFakesIndexRoute,
  }

const AuthenticatedUsersRouteRouteWithChildren =
  AuthenticatedUsersRouteRoute._addFileChildren(
    AuthenticatedUsersRouteRouteChildren,
  )

interface AuthenticatedRouteRouteChildren {
  AuthenticatedCitiesRouteRoute: typeof AuthenticatedCitiesRouteRouteWithChildren
  AuthenticatedCoinTransactionsRouteRoute: typeof AuthenticatedCoinTransactionsRouteRouteWithChildren
  AuthenticatedCrmRouteRoute: typeof AuthenticatedCrmRouteRouteWithChildren
  AuthenticatedEventCategoriesRouteRoute: typeof AuthenticatedEventCategoriesRouteRouteWithChildren
  AuthenticatedEventsRouteRoute: typeof AuthenticatedEventsRouteRouteWithChildren
  AuthenticatedExtractorConfigRouteRoute: typeof AuthenticatedExtractorConfigRouteRouteWithChildren
  AuthenticatedImportQueueRouteRoute: typeof AuthenticatedImportQueueRouteRouteWithChildren
  AuthenticatedMeetingTemplatesRouteRoute: typeof AuthenticatedMeetingTemplatesRouteRouteWithChildren
  AuthenticatedNewsRouteRoute: typeof AuthenticatedNewsRouteRouteWithChildren
  AuthenticatedOrganizerBlocksRouteRoute: typeof AuthenticatedOrganizerBlocksRouteRouteWithChildren
  AuthenticatedPaymentProvidersRouteRoute: typeof AuthenticatedPaymentProvidersRouteRouteWithChildren
  AuthenticatedPlaceCategoriesRouteRoute: typeof AuthenticatedPlaceCategoriesRouteRouteWithChildren
  AuthenticatedPlacesRouteRoute: typeof AuthenticatedPlacesRouteRouteWithChildren
  AuthenticatedPromotionTasksRouteRoute: typeof AuthenticatedPromotionTasksRouteRouteWithChildren
  AuthenticatedServiceCategoriesRouteRoute: typeof AuthenticatedServiceCategoriesRouteRouteWithChildren
  AuthenticatedServicesRouteRoute: typeof AuthenticatedServicesRouteRouteWithChildren
  AuthenticatedSourceChannelsRouteRoute: typeof AuthenticatedSourceChannelsRouteRouteWithChildren
  AuthenticatedUsersRouteRoute: typeof AuthenticatedUsersRouteRouteWithChildren
  AuthenticatedMorningDigestRoute: typeof AuthenticatedMorningDigestRoute
  AuthenticatedPhotoModerationRoute: typeof AuthenticatedPhotoModerationRoute
  AuthenticatedIndexRoute: typeof AuthenticatedIndexRoute
}

const AuthenticatedRouteRouteChildren: AuthenticatedRouteRouteChildren = {
  AuthenticatedCitiesRouteRoute: AuthenticatedCitiesRouteRouteWithChildren,
  AuthenticatedCoinTransactionsRouteRoute:
    AuthenticatedCoinTransactionsRouteRouteWithChildren,
  AuthenticatedCrmRouteRoute: AuthenticatedCrmRouteRouteWithChildren,
  AuthenticatedEventCategoriesRouteRoute:
    AuthenticatedEventCategoriesRouteRouteWithChildren,
  AuthenticatedEventsRouteRoute: AuthenticatedEventsRouteRouteWithChildren,
  AuthenticatedExtractorConfigRouteRoute:
    AuthenticatedExtractorConfigRouteRouteWithChildren,
  AuthenticatedImportQueueRouteRoute:
    AuthenticatedImportQueueRouteRouteWithChildren,
  AuthenticatedMeetingTemplatesRouteRoute:
    AuthenticatedMeetingTemplatesRouteRouteWithChildren,
  AuthenticatedNewsRouteRoute: AuthenticatedNewsRouteRouteWithChildren,
  AuthenticatedOrganizerBlocksRouteRoute:
    AuthenticatedOrganizerBlocksRouteRouteWithChildren,
  AuthenticatedPaymentProvidersRouteRoute:
    AuthenticatedPaymentProvidersRouteRouteWithChildren,
  AuthenticatedPlaceCategoriesRouteRoute:
    AuthenticatedPlaceCategoriesRouteRouteWithChildren,
  AuthenticatedPlacesRouteRoute: AuthenticatedPlacesRouteRouteWithChildren,
  AuthenticatedPromotionTasksRouteRoute:
    AuthenticatedPromotionTasksRouteRouteWithChildren,
  AuthenticatedServiceCategoriesRouteRoute:
    AuthenticatedServiceCategoriesRouteRouteWithChildren,
  AuthenticatedServicesRouteRoute: AuthenticatedServicesRouteRouteWithChildren,
  AuthenticatedSourceChannelsRouteRoute:
    AuthenticatedSourceChannelsRouteRouteWithChildren,
  AuthenticatedUsersRouteRoute: AuthenticatedUsersRouteRouteWithChildren,
  AuthenticatedMorningDigestRoute: AuthenticatedMorningDigestRoute,
  AuthenticatedPhotoModerationRoute: AuthenticatedPhotoModerationRoute,
  AuthenticatedIndexRoute: AuthenticatedIndexRoute,
}

const AuthenticatedRouteRouteWithChildren =
  AuthenticatedRouteRoute._addFileChildren(AuthenticatedRouteRouteChildren)

interface PublicRouteRouteChildren {
  PublicLoginRoute: typeof PublicLoginRoute
  PublicAuthTelegramCallbackRoute: typeof PublicAuthTelegramCallbackRoute
}

const PublicRouteRouteChildren: PublicRouteRouteChildren = {
  PublicLoginRoute: PublicLoginRoute,
  PublicAuthTelegramCallbackRoute: PublicAuthTelegramCallbackRoute,
}

const PublicRouteRouteWithChildren = PublicRouteRoute._addFileChildren(
  PublicRouteRouteChildren,
)

export interface FileRoutesByFullPath {
  '': typeof PublicRouteRouteWithChildren
  '/cities': typeof AuthenticatedCitiesRouteRouteWithChildren
  '/coin-transactions': typeof AuthenticatedCoinTransactionsRouteRouteWithChildren
  '/crm': typeof AuthenticatedCrmRouteRouteWithChildren
  '/event-categories': typeof AuthenticatedEventCategoriesRouteRouteWithChildren
  '/events': typeof AuthenticatedEventsRouteRouteWithChildren
  '/extractor-config': typeof AuthenticatedExtractorConfigRouteRouteWithChildren
  '/import-queue': typeof AuthenticatedImportQueueRouteRouteWithChildren
  '/meeting-templates': typeof AuthenticatedMeetingTemplatesRouteRouteWithChildren
  '/news': typeof AuthenticatedNewsRouteRouteWithChildren
  '/organizer-blocks': typeof AuthenticatedOrganizerBlocksRouteRouteWithChildren
  '/payment-providers': typeof AuthenticatedPaymentProvidersRouteRouteWithChildren
  '/place-categories': typeof AuthenticatedPlaceCategoriesRouteRouteWithChildren
  '/places': typeof AuthenticatedPlacesRouteRouteWithChildren
  '/promotion-tasks': typeof AuthenticatedPromotionTasksRouteRouteWithChildren
  '/service-categories': typeof AuthenticatedServiceCategoriesRouteRouteWithChildren
  '/services': typeof AuthenticatedServicesRouteRouteWithChildren
  '/source-channels': typeof AuthenticatedSourceChannelsRouteRouteWithChildren
  '/users': typeof AuthenticatedUsersRouteRouteWithChildren
  '/morning-digest': typeof AuthenticatedMorningDigestRoute
  '/photo-moderation': typeof AuthenticatedPhotoModerationRoute
  '/login': typeof PublicLoginRoute
  '/': typeof AuthenticatedIndexRoute
  '/cities/$cityId': typeof AuthenticatedCitiesCityIdRoute
  '/cities/new': typeof AuthenticatedCitiesNewRoute
  '/crm/conversations': typeof AuthenticatedCrmConversationsRoute
  '/crm/events': typeof AuthenticatedCrmEventsRoute
  '/crm/instagram': typeof AuthenticatedCrmInstagramRoute
  '/crm/telegram': typeof AuthenticatedCrmTelegramRoute
  '/event-categories/$categoryId': typeof AuthenticatedEventCategoriesCategoryIdRoute
  '/event-categories/new': typeof AuthenticatedEventCategoriesNewRoute
  '/events/$eventId': typeof AuthenticatedEventsEventIdRoute
  '/events/new': typeof AuthenticatedEventsNewRoute
  '/import-queue/$messageId': typeof AuthenticatedImportQueueMessageIdRoute
  '/meeting-templates/$templateId': typeof AuthenticatedMeetingTemplatesTemplateIdRoute
  '/meeting-templates/new': typeof AuthenticatedMeetingTemplatesNewRoute
  '/payment-providers/$providerId': typeof AuthenticatedPaymentProvidersProviderIdRoute
  '/payment-providers/new': typeof AuthenticatedPaymentProvidersNewRoute
  '/place-categories/$categoryId': typeof AuthenticatedPlaceCategoriesCategoryIdRoute
  '/place-categories/new': typeof AuthenticatedPlaceCategoriesNewRoute
  '/places/$placeId': typeof AuthenticatedPlacesPlaceIdRoute
  '/places/new': typeof AuthenticatedPlacesNewRoute
  '/service-categories/$categoryId': typeof AuthenticatedServiceCategoriesCategoryIdRoute
  '/service-categories/new': typeof AuthenticatedServiceCategoriesNewRoute
  '/services/$serviceId': typeof AuthenticatedServicesServiceIdRoute
  '/source-channels/$channelId': typeof AuthenticatedSourceChannelsChannelIdRoute
  '/source-channels/new': typeof AuthenticatedSourceChannelsNewRoute
  '/users/$userId': typeof AuthenticatedUsersUserIdRoute
  '/auth/telegram-callback': typeof PublicAuthTelegramCallbackRoute
  '/cities/': typeof AuthenticatedCitiesIndexRoute
  '/coin-transactions/': typeof AuthenticatedCoinTransactionsIndexRoute
  '/crm/': typeof AuthenticatedCrmIndexRoute
  '/event-categories/': typeof AuthenticatedEventCategoriesIndexRoute
  '/events/': typeof AuthenticatedEventsIndexRoute
  '/extractor-config/': typeof AuthenticatedExtractorConfigIndexRoute
  '/import-queue/': typeof AuthenticatedImportQueueIndexRoute
  '/meeting-templates/': typeof AuthenticatedMeetingTemplatesIndexRoute
  '/news/': typeof AuthenticatedNewsIndexRoute
  '/organizer-blocks/': typeof AuthenticatedOrganizerBlocksIndexRoute
  '/payment-providers/': typeof AuthenticatedPaymentProvidersIndexRoute
  '/place-categories/': typeof AuthenticatedPlaceCategoriesIndexRoute
  '/places/': typeof AuthenticatedPlacesIndexRoute
  '/promotion-tasks/': typeof AuthenticatedPromotionTasksIndexRoute
  '/service-categories/': typeof AuthenticatedServiceCategoriesIndexRoute
  '/services/': typeof AuthenticatedServicesIndexRoute
  '/source-channels/': typeof AuthenticatedSourceChannelsIndexRoute
  '/users/': typeof AuthenticatedUsersIndexRoute
  '/users/fakes/$fakeId': typeof AuthenticatedUsersFakesFakeIdRoute
  '/users/fakes/new': typeof AuthenticatedUsersFakesNewRoute
  '/users/fakes': typeof AuthenticatedUsersFakesIndexRoute
}

export interface FileRoutesByTo {
  '': typeof PublicRouteRouteWithChildren
  '/morning-digest': typeof AuthenticatedMorningDigestRoute
  '/photo-moderation': typeof AuthenticatedPhotoModerationRoute
  '/login': typeof PublicLoginRoute
  '/': typeof AuthenticatedIndexRoute
  '/cities/$cityId': typeof AuthenticatedCitiesCityIdRoute
  '/cities/new': typeof AuthenticatedCitiesNewRoute
  '/crm/conversations': typeof AuthenticatedCrmConversationsRoute
  '/crm/events': typeof AuthenticatedCrmEventsRoute
  '/crm/instagram': typeof AuthenticatedCrmInstagramRoute
  '/crm/telegram': typeof AuthenticatedCrmTelegramRoute
  '/event-categories/$categoryId': typeof AuthenticatedEventCategoriesCategoryIdRoute
  '/event-categories/new': typeof AuthenticatedEventCategoriesNewRoute
  '/events/$eventId': typeof AuthenticatedEventsEventIdRoute
  '/events/new': typeof AuthenticatedEventsNewRoute
  '/import-queue/$messageId': typeof AuthenticatedImportQueueMessageIdRoute
  '/meeting-templates/$templateId': typeof AuthenticatedMeetingTemplatesTemplateIdRoute
  '/meeting-templates/new': typeof AuthenticatedMeetingTemplatesNewRoute
  '/payment-providers/$providerId': typeof AuthenticatedPaymentProvidersProviderIdRoute
  '/payment-providers/new': typeof AuthenticatedPaymentProvidersNewRoute
  '/place-categories/$categoryId': typeof AuthenticatedPlaceCategoriesCategoryIdRoute
  '/place-categories/new': typeof AuthenticatedPlaceCategoriesNewRoute
  '/places/$placeId': typeof AuthenticatedPlacesPlaceIdRoute
  '/places/new': typeof AuthenticatedPlacesNewRoute
  '/service-categories/$categoryId': typeof AuthenticatedServiceCategoriesCategoryIdRoute
  '/service-categories/new': typeof AuthenticatedServiceCategoriesNewRoute
  '/services/$serviceId': typeof AuthenticatedServicesServiceIdRoute
  '/source-channels/$channelId': typeof AuthenticatedSourceChannelsChannelIdRoute
  '/source-channels/new': typeof AuthenticatedSourceChannelsNewRoute
  '/users/$userId': typeof AuthenticatedUsersUserIdRoute
  '/auth/telegram-callback': typeof PublicAuthTelegramCallbackRoute
  '/cities': typeof AuthenticatedCitiesIndexRoute
  '/coin-transactions': typeof AuthenticatedCoinTransactionsIndexRoute
  '/crm': typeof AuthenticatedCrmIndexRoute
  '/event-categories': typeof AuthenticatedEventCategoriesIndexRoute
  '/events': typeof AuthenticatedEventsIndexRoute
  '/extractor-config': typeof AuthenticatedExtractorConfigIndexRoute
  '/import-queue': typeof AuthenticatedImportQueueIndexRoute
  '/meeting-templates': typeof AuthenticatedMeetingTemplatesIndexRoute
  '/news': typeof AuthenticatedNewsIndexRoute
  '/organizer-blocks': typeof AuthenticatedOrganizerBlocksIndexRoute
  '/payment-providers': typeof AuthenticatedPaymentProvidersIndexRoute
  '/place-categories': typeof AuthenticatedPlaceCategoriesIndexRoute
  '/places': typeof AuthenticatedPlacesIndexRoute
  '/promotion-tasks': typeof AuthenticatedPromotionTasksIndexRoute
  '/service-categories': typeof AuthenticatedServiceCategoriesIndexRoute
  '/services': typeof AuthenticatedServicesIndexRoute
  '/source-channels': typeof AuthenticatedSourceChannelsIndexRoute
  '/users': typeof AuthenticatedUsersIndexRoute
  '/users/fakes/$fakeId': typeof AuthenticatedUsersFakesFakeIdRoute
  '/users/fakes/new': typeof AuthenticatedUsersFakesNewRoute
  '/users/fakes': typeof AuthenticatedUsersFakesIndexRoute
}

export interface FileRoutesById {
  __root__: typeof rootRoute
  '/_authenticated': typeof AuthenticatedRouteRouteWithChildren
  '/_public': typeof PublicRouteRouteWithChildren
  '/_authenticated/cities': typeof AuthenticatedCitiesRouteRouteWithChildren
  '/_authenticated/coin-transactions': typeof AuthenticatedCoinTransactionsRouteRouteWithChildren
  '/_authenticated/crm': typeof AuthenticatedCrmRouteRouteWithChildren
  '/_authenticated/event-categories': typeof AuthenticatedEventCategoriesRouteRouteWithChildren
  '/_authenticated/events': typeof AuthenticatedEventsRouteRouteWithChildren
  '/_authenticated/extractor-config': typeof AuthenticatedExtractorConfigRouteRouteWithChildren
  '/_authenticated/import-queue': typeof AuthenticatedImportQueueRouteRouteWithChildren
  '/_authenticated/meeting-templates': typeof AuthenticatedMeetingTemplatesRouteRouteWithChildren
  '/_authenticated/news': typeof AuthenticatedNewsRouteRouteWithChildren
  '/_authenticated/organizer-blocks': typeof AuthenticatedOrganizerBlocksRouteRouteWithChildren
  '/_authenticated/payment-providers': typeof AuthenticatedPaymentProvidersRouteRouteWithChildren
  '/_authenticated/place-categories': typeof AuthenticatedPlaceCategoriesRouteRouteWithChildren
  '/_authenticated/places': typeof AuthenticatedPlacesRouteRouteWithChildren
  '/_authenticated/promotion-tasks': typeof AuthenticatedPromotionTasksRouteRouteWithChildren
  '/_authenticated/service-categories': typeof AuthenticatedServiceCategoriesRouteRouteWithChildren
  '/_authenticated/services': typeof AuthenticatedServicesRouteRouteWithChildren
  '/_authenticated/source-channels': typeof AuthenticatedSourceChannelsRouteRouteWithChildren
  '/_authenticated/users': typeof AuthenticatedUsersRouteRouteWithChildren
  '/_authenticated/morning-digest': typeof AuthenticatedMorningDigestRoute
  '/_authenticated/photo-moderation': typeof AuthenticatedPhotoModerationRoute
  '/_public/login': typeof PublicLoginRoute
  '/_authenticated/': typeof AuthenticatedIndexRoute
  '/_authenticated/cities/$cityId': typeof AuthenticatedCitiesCityIdRoute
  '/_authenticated/cities/new': typeof AuthenticatedCitiesNewRoute
  '/_authenticated/crm/conversations': typeof AuthenticatedCrmConversationsRoute
  '/_authenticated/crm/events': typeof AuthenticatedCrmEventsRoute
  '/_authenticated/crm/instagram': typeof AuthenticatedCrmInstagramRoute
  '/_authenticated/crm/telegram': typeof AuthenticatedCrmTelegramRoute
  '/_authenticated/event-categories/$categoryId': typeof AuthenticatedEventCategoriesCategoryIdRoute
  '/_authenticated/event-categories/new': typeof AuthenticatedEventCategoriesNewRoute
  '/_authenticated/events/$eventId': typeof AuthenticatedEventsEventIdRoute
  '/_authenticated/events/new': typeof AuthenticatedEventsNewRoute
  '/_authenticated/import-queue/$messageId': typeof AuthenticatedImportQueueMessageIdRoute
  '/_authenticated/meeting-templates/$templateId': typeof AuthenticatedMeetingTemplatesTemplateIdRoute
  '/_authenticated/meeting-templates/new': typeof AuthenticatedMeetingTemplatesNewRoute
  '/_authenticated/payment-providers/$providerId': typeof AuthenticatedPaymentProvidersProviderIdRoute
  '/_authenticated/payment-providers/new': typeof AuthenticatedPaymentProvidersNewRoute
  '/_authenticated/place-categories/$categoryId': typeof AuthenticatedPlaceCategoriesCategoryIdRoute
  '/_authenticated/place-categories/new': typeof AuthenticatedPlaceCategoriesNewRoute
  '/_authenticated/places/$placeId': typeof AuthenticatedPlacesPlaceIdRoute
  '/_authenticated/places/new': typeof AuthenticatedPlacesNewRoute
  '/_authenticated/service-categories/$categoryId': typeof AuthenticatedServiceCategoriesCategoryIdRoute
  '/_authenticated/service-categories/new': typeof AuthenticatedServiceCategoriesNewRoute
  '/_authenticated/services/$serviceId': typeof AuthenticatedServicesServiceIdRoute
  '/_authenticated/source-channels/$channelId': typeof AuthenticatedSourceChannelsChannelIdRoute
  '/_authenticated/source-channels/new': typeof AuthenticatedSourceChannelsNewRoute
  '/_authenticated/users/$userId': typeof AuthenticatedUsersUserIdRoute
  '/_public/auth/telegram-callback': typeof PublicAuthTelegramCallbackRoute
  '/_authenticated/cities/': typeof AuthenticatedCitiesIndexRoute
  '/_authenticated/coin-transactions/': typeof AuthenticatedCoinTransactionsIndexRoute
  '/_authenticated/crm/': typeof AuthenticatedCrmIndexRoute
  '/_authenticated/event-categories/': typeof AuthenticatedEventCategoriesIndexRoute
  '/_authenticated/events/': typeof AuthenticatedEventsIndexRoute
  '/_authenticated/extractor-config/': typeof AuthenticatedExtractorConfigIndexRoute
  '/_authenticated/import-queue/': typeof AuthenticatedImportQueueIndexRoute
  '/_authenticated/meeting-templates/': typeof AuthenticatedMeetingTemplatesIndexRoute
  '/_authenticated/news/': typeof AuthenticatedNewsIndexRoute
  '/_authenticated/organizer-blocks/': typeof AuthenticatedOrganizerBlocksIndexRoute
  '/_authenticated/payment-providers/': typeof AuthenticatedPaymentProvidersIndexRoute
  '/_authenticated/place-categories/': typeof AuthenticatedPlaceCategoriesIndexRoute
  '/_authenticated/places/': typeof AuthenticatedPlacesIndexRoute
  '/_authenticated/promotion-tasks/': typeof AuthenticatedPromotionTasksIndexRoute
  '/_authenticated/service-categories/': typeof AuthenticatedServiceCategoriesIndexRoute
  '/_authenticated/services/': typeof AuthenticatedServicesIndexRoute
  '/_authenticated/source-channels/': typeof AuthenticatedSourceChannelsIndexRoute
  '/_authenticated/users/': typeof AuthenticatedUsersIndexRoute
  '/_authenticated/users/fakes/$fakeId': typeof AuthenticatedUsersFakesFakeIdRoute
  '/_authenticated/users/fakes/new': typeof AuthenticatedUsersFakesNewRoute
  '/_authenticated/users/fakes/': typeof AuthenticatedUsersFakesIndexRoute
}

export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | ''
    | '/cities'
    | '/coin-transactions'
    | '/crm'
    | '/event-categories'
    | '/events'
    | '/extractor-config'
    | '/import-queue'
    | '/meeting-templates'
    | '/news'
    | '/organizer-blocks'
    | '/payment-providers'
    | '/place-categories'
    | '/places'
    | '/promotion-tasks'
    | '/service-categories'
    | '/services'
    | '/source-channels'
    | '/users'
    | '/morning-digest'
    | '/photo-moderation'
    | '/login'
    | '/'
    | '/cities/$cityId'
    | '/cities/new'
    | '/crm/conversations'
    | '/crm/events'
    | '/crm/instagram'
    | '/crm/telegram'
    | '/event-categories/$categoryId'
    | '/event-categories/new'
    | '/events/$eventId'
    | '/events/new'
    | '/import-queue/$messageId'
    | '/meeting-templates/$templateId'
    | '/meeting-templates/new'
    | '/payment-providers/$providerId'
    | '/payment-providers/new'
    | '/place-categories/$categoryId'
    | '/place-categories/new'
    | '/places/$placeId'
    | '/places/new'
    | '/service-categories/$categoryId'
    | '/service-categories/new'
    | '/services/$serviceId'
    | '/source-channels/$channelId'
    | '/source-channels/new'
    | '/users/$userId'
    | '/auth/telegram-callback'
    | '/cities/'
    | '/coin-transactions/'
    | '/crm/'
    | '/event-categories/'
    | '/events/'
    | '/extractor-config/'
    | '/import-queue/'
    | '/meeting-templates/'
    | '/news/'
    | '/organizer-blocks/'
    | '/payment-providers/'
    | '/place-categories/'
    | '/places/'
    | '/promotion-tasks/'
    | '/service-categories/'
    | '/services/'
    | '/source-channels/'
    | '/users/'
    | '/users/fakes/$fakeId'
    | '/users/fakes/new'
    | '/users/fakes'
  fileRoutesByTo: FileRoutesByTo
  to:
    | ''
    | '/morning-digest'
    | '/photo-moderation'
    | '/login'
    | '/'
    | '/cities/$cityId'
    | '/cities/new'
    | '/crm/conversations'
    | '/crm/events'
    | '/crm/instagram'
    | '/crm/telegram'
    | '/event-categories/$categoryId'
    | '/event-categories/new'
    | '/events/$eventId'
    | '/events/new'
    | '/import-queue/$messageId'
    | '/meeting-templates/$templateId'
    | '/meeting-templates/new'
    | '/payment-providers/$providerId'
    | '/payment-providers/new'
    | '/place-categories/$categoryId'
    | '/place-categories/new'
    | '/places/$placeId'
    | '/places/new'
    | '/service-categories/$categoryId'
    | '/service-categories/new'
    | '/services/$serviceId'
    | '/source-channels/$channelId'
    | '/source-channels/new'
    | '/users/$userId'
    | '/auth/telegram-callback'
    | '/cities'
    | '/coin-transactions'
    | '/crm'
    | '/event-categories'
    | '/events'
    | '/extractor-config'
    | '/import-queue'
    | '/meeting-templates'
    | '/news'
    | '/organizer-blocks'
    | '/payment-providers'
    | '/place-categories'
    | '/places'
    | '/promotion-tasks'
    | '/service-categories'
    | '/services'
    | '/source-channels'
    | '/users'
    | '/users/fakes/$fakeId'
    | '/users/fakes/new'
    | '/users/fakes'
  id:
    | '__root__'
    | '/_authenticated'
    | '/_public'
    | '/_authenticated/cities'
    | '/_authenticated/coin-transactions'
    | '/_authenticated/crm'
    | '/_authenticated/event-categories'
    | '/_authenticated/events'
    | '/_authenticated/extractor-config'
    | '/_authenticated/import-queue'
    | '/_authenticated/meeting-templates'
    | '/_authenticated/news'
    | '/_authenticated/organizer-blocks'
    | '/_authenticated/payment-providers'
    | '/_authenticated/place-categories'
    | '/_authenticated/places'
    | '/_authenticated/promotion-tasks'
    | '/_authenticated/service-categories'
    | '/_authenticated/services'
    | '/_authenticated/source-channels'
    | '/_authenticated/users'
    | '/_authenticated/morning-digest'
    | '/_authenticated/photo-moderation'
    | '/_public/login'
    | '/_authenticated/'
    | '/_authenticated/cities/$cityId'
    | '/_authenticated/cities/new'
    | '/_authenticated/crm/conversations'
    | '/_authenticated/crm/events'
    | '/_authenticated/crm/instagram'
    | '/_authenticated/crm/telegram'
    | '/_authenticated/event-categories/$categoryId'
    | '/_authenticated/event-categories/new'
    | '/_authenticated/events/$eventId'
    | '/_authenticated/events/new'
    | '/_authenticated/import-queue/$messageId'
    | '/_authenticated/meeting-templates/$templateId'
    | '/_authenticated/meeting-templates/new'
    | '/_authenticated/payment-providers/$providerId'
    | '/_authenticated/payment-providers/new'
    | '/_authenticated/place-categories/$categoryId'
    | '/_authenticated/place-categories/new'
    | '/_authenticated/places/$placeId'
    | '/_authenticated/places/new'
    | '/_authenticated/service-categories/$categoryId'
    | '/_authenticated/service-categories/new'
    | '/_authenticated/services/$serviceId'
    | '/_authenticated/source-channels/$channelId'
    | '/_authenticated/source-channels/new'
    | '/_authenticated/users/$userId'
    | '/_public/auth/telegram-callback'
    | '/_authenticated/cities/'
    | '/_authenticated/coin-transactions/'
    | '/_authenticated/crm/'
    | '/_authenticated/event-categories/'
    | '/_authenticated/events/'
    | '/_authenticated/extractor-config/'
    | '/_authenticated/import-queue/'
    | '/_authenticated/meeting-templates/'
    | '/_authenticated/news/'
    | '/_authenticated/organizer-blocks/'
    | '/_authenticated/payment-providers/'
    | '/_authenticated/place-categories/'
    | '/_authenticated/places/'
    | '/_authenticated/promotion-tasks/'
    | '/_authenticated/service-categories/'
    | '/_authenticated/services/'
    | '/_authenticated/source-channels/'
    | '/_authenticated/users/'
    | '/_authenticated/users/fakes/$fakeId'
    | '/_authenticated/users/fakes/new'
    | '/_authenticated/users/fakes/'
  fileRoutesById: FileRoutesById
}

export interface RootRouteChildren {
  AuthenticatedRouteRoute: typeof AuthenticatedRouteRouteWithChildren
  PublicRouteRoute: typeof PublicRouteRouteWithChildren
}

const rootRouteChildren: RootRouteChildren = {
  AuthenticatedRouteRoute: AuthenticatedRouteRouteWithChildren,
  PublicRouteRoute: PublicRouteRouteWithChildren,
}

export const routeTree = rootRoute
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()

/* ROUTE_MANIFEST_START
{
  "routes": {
    "__root__": {
      "filePath": "__root.tsx",
      "children": [
        "/_authenticated",
        "/_public"
      ]
    },
    "/_authenticated": {
      "filePath": "_authenticated/route.tsx",
      "children": [
        "/_authenticated/cities",
        "/_authenticated/coin-transactions",
        "/_authenticated/crm",
        "/_authenticated/event-categories",
        "/_authenticated/events",
        "/_authenticated/extractor-config",
        "/_authenticated/import-queue",
        "/_authenticated/meeting-templates",
        "/_authenticated/news",
        "/_authenticated/organizer-blocks",
        "/_authenticated/payment-providers",
        "/_authenticated/place-categories",
        "/_authenticated/places",
        "/_authenticated/promotion-tasks",
        "/_authenticated/service-categories",
        "/_authenticated/services",
        "/_authenticated/source-channels",
        "/_authenticated/users",
        "/_authenticated/morning-digest",
        "/_authenticated/photo-moderation",
        "/_authenticated/"
      ]
    },
    "/_public": {
      "filePath": "_public/route.tsx",
      "children": [
        "/_public/login",
        "/_public/auth/telegram-callback"
      ]
    },
    "/_authenticated/cities": {
      "filePath": "_authenticated/cities/route.tsx",
      "parent": "/_authenticated",
      "children": [
        "/_authenticated/cities/$cityId",
        "/_authenticated/cities/new",
        "/_authenticated/cities/"
      ]
    },
    "/_authenticated/coin-transactions": {
      "filePath": "_authenticated/coin-transactions/route.tsx",
      "parent": "/_authenticated",
      "children": [
        "/_authenticated/coin-transactions/"
      ]
    },
    "/_authenticated/crm": {
      "filePath": "_authenticated/crm/route.tsx",
      "parent": "/_authenticated",
      "children": [
        "/_authenticated/crm/conversations",
        "/_authenticated/crm/events",
        "/_authenticated/crm/instagram",
        "/_authenticated/crm/telegram",
        "/_authenticated/crm/"
      ]
    },
    "/_authenticated/event-categories": {
      "filePath": "_authenticated/event-categories/route.tsx",
      "parent": "/_authenticated",
      "children": [
        "/_authenticated/event-categories/$categoryId",
        "/_authenticated/event-categories/new",
        "/_authenticated/event-categories/"
      ]
    },
    "/_authenticated/events": {
      "filePath": "_authenticated/events/route.tsx",
      "parent": "/_authenticated",
      "children": [
        "/_authenticated/events/$eventId",
        "/_authenticated/events/new",
        "/_authenticated/events/"
      ]
    },
    "/_authenticated/extractor-config": {
      "filePath": "_authenticated/extractor-config/route.tsx",
      "parent": "/_authenticated",
      "children": [
        "/_authenticated/extractor-config/"
      ]
    },
    "/_authenticated/import-queue": {
      "filePath": "_authenticated/import-queue/route.tsx",
      "parent": "/_authenticated",
      "children": [
        "/_authenticated/import-queue/$messageId",
        "/_authenticated/import-queue/"
      ]
    },
    "/_authenticated/meeting-templates": {
      "filePath": "_authenticated/meeting-templates/route.tsx",
      "parent": "/_authenticated",
      "children": [
        "/_authenticated/meeting-templates/$templateId",
        "/_authenticated/meeting-templates/new",
        "/_authenticated/meeting-templates/"
      ]
    },
    "/_authenticated/news": {
      "filePath": "_authenticated/news/route.tsx",
      "parent": "/_authenticated",
      "children": [
        "/_authenticated/news/"
      ]
    },
    "/_authenticated/organizer-blocks": {
      "filePath": "_authenticated/organizer-blocks/route.tsx",
      "parent": "/_authenticated",
      "children": [
        "/_authenticated/organizer-blocks/"
      ]
    },
    "/_authenticated/payment-providers": {
      "filePath": "_authenticated/payment-providers/route.tsx",
      "parent": "/_authenticated",
      "children": [
        "/_authenticated/payment-providers/$providerId",
        "/_authenticated/payment-providers/new",
        "/_authenticated/payment-providers/"
      ]
    },
    "/_authenticated/place-categories": {
      "filePath": "_authenticated/place-categories/route.tsx",
      "parent": "/_authenticated",
      "children": [
        "/_authenticated/place-categories/$categoryId",
        "/_authenticated/place-categories/new",
        "/_authenticated/place-categories/"
      ]
    },
    "/_authenticated/places": {
      "filePath": "_authenticated/places/route.tsx",
      "parent": "/_authenticated",
      "children": [
        "/_authenticated/places/$placeId",
        "/_authenticated/places/new",
        "/_authenticated/places/"
      ]
    },
    "/_authenticated/promotion-tasks": {
      "filePath": "_authenticated/promotion-tasks/route.tsx",
      "parent": "/_authenticated",
      "children": [
        "/_authenticated/promotion-tasks/"
      ]
    },
    "/_authenticated/service-categories": {
      "filePath": "_authenticated/service-categories/route.tsx",
      "parent": "/_authenticated",
      "children": [
        "/_authenticated/service-categories/$categoryId",
        "/_authenticated/service-categories/new",
        "/_authenticated/service-categories/"
      ]
    },
    "/_authenticated/services": {
      "filePath": "_authenticated/services/route.tsx",
      "parent": "/_authenticated",
      "children": [
        "/_authenticated/services/$serviceId",
        "/_authenticated/services/"
      ]
    },
    "/_authenticated/source-channels": {
      "filePath": "_authenticated/source-channels/route.tsx",
      "parent": "/_authenticated",
      "children": [
        "/_authenticated/source-channels/$channelId",
        "/_authenticated/source-channels/new",
        "/_authenticated/source-channels/"
      ]
    },
    "/_authenticated/users": {
      "filePath": "_authenticated/users/route.tsx",
      "parent": "/_authenticated",
      "children": [
        "/_authenticated/users/$userId",
        "/_authenticated/users/",
        "/_authenticated/users/fakes/$fakeId",
        "/_authenticated/users/fakes/new",
        "/_authenticated/users/fakes/"
      ]
    },
    "/_authenticated/morning-digest": {
      "filePath": "_authenticated/morning-digest.tsx",
      "parent": "/_authenticated"
    },
    "/_authenticated/photo-moderation": {
      "filePath": "_authenticated/photo-moderation.tsx",
      "parent": "/_authenticated"
    },
    "/_public/login": {
      "filePath": "_public/login.tsx",
      "parent": "/_public"
    },
    "/_authenticated/": {
      "filePath": "_authenticated/index.tsx",
      "parent": "/_authenticated"
    },
    "/_authenticated/cities/$cityId": {
      "filePath": "_authenticated/cities/$cityId.tsx",
      "parent": "/_authenticated/cities"
    },
    "/_authenticated/cities/new": {
      "filePath": "_authenticated/cities/new.tsx",
      "parent": "/_authenticated/cities"
    },
    "/_authenticated/crm/conversations": {
      "filePath": "_authenticated/crm/conversations.tsx",
      "parent": "/_authenticated/crm"
    },
    "/_authenticated/crm/events": {
      "filePath": "_authenticated/crm/events.tsx",
      "parent": "/_authenticated/crm"
    },
    "/_authenticated/crm/instagram": {
      "filePath": "_authenticated/crm/instagram.tsx",
      "parent": "/_authenticated/crm"
    },
    "/_authenticated/crm/telegram": {
      "filePath": "_authenticated/crm/telegram.tsx",
      "parent": "/_authenticated/crm"
    },
    "/_authenticated/event-categories/$categoryId": {
      "filePath": "_authenticated/event-categories/$categoryId.tsx",
      "parent": "/_authenticated/event-categories"
    },
    "/_authenticated/event-categories/new": {
      "filePath": "_authenticated/event-categories/new.tsx",
      "parent": "/_authenticated/event-categories"
    },
    "/_authenticated/events/$eventId": {
      "filePath": "_authenticated/events/$eventId.tsx",
      "parent": "/_authenticated/events"
    },
    "/_authenticated/events/new": {
      "filePath": "_authenticated/events/new.tsx",
      "parent": "/_authenticated/events"
    },
    "/_authenticated/import-queue/$messageId": {
      "filePath": "_authenticated/import-queue/$messageId.tsx",
      "parent": "/_authenticated/import-queue"
    },
    "/_authenticated/meeting-templates/$templateId": {
      "filePath": "_authenticated/meeting-templates/$templateId.tsx",
      "parent": "/_authenticated/meeting-templates"
    },
    "/_authenticated/meeting-templates/new": {
      "filePath": "_authenticated/meeting-templates/new.tsx",
      "parent": "/_authenticated/meeting-templates"
    },
    "/_authenticated/payment-providers/$providerId": {
      "filePath": "_authenticated/payment-providers/$providerId.tsx",
      "parent": "/_authenticated/payment-providers"
    },
    "/_authenticated/payment-providers/new": {
      "filePath": "_authenticated/payment-providers/new.tsx",
      "parent": "/_authenticated/payment-providers"
    },
    "/_authenticated/place-categories/$categoryId": {
      "filePath": "_authenticated/place-categories/$categoryId.tsx",
      "parent": "/_authenticated/place-categories"
    },
    "/_authenticated/place-categories/new": {
      "filePath": "_authenticated/place-categories/new.tsx",
      "parent": "/_authenticated/place-categories"
    },
    "/_authenticated/places/$placeId": {
      "filePath": "_authenticated/places/$placeId.tsx",
      "parent": "/_authenticated/places"
    },
    "/_authenticated/places/new": {
      "filePath": "_authenticated/places/new.tsx",
      "parent": "/_authenticated/places"
    },
    "/_authenticated/service-categories/$categoryId": {
      "filePath": "_authenticated/service-categories/$categoryId.tsx",
      "parent": "/_authenticated/service-categories"
    },
    "/_authenticated/service-categories/new": {
      "filePath": "_authenticated/service-categories/new.tsx",
      "parent": "/_authenticated/service-categories"
    },
    "/_authenticated/services/$serviceId": {
      "filePath": "_authenticated/services/$serviceId.tsx",
      "parent": "/_authenticated/services"
    },
    "/_authenticated/source-channels/$channelId": {
      "filePath": "_authenticated/source-channels/$channelId.tsx",
      "parent": "/_authenticated/source-channels"
    },
    "/_authenticated/source-channels/new": {
      "filePath": "_authenticated/source-channels/new.tsx",
      "parent": "/_authenticated/source-channels"
    },
    "/_authenticated/users/$userId": {
      "filePath": "_authenticated/users/$userId.tsx",
      "parent": "/_authenticated/users"
    },
    "/_public/auth/telegram-callback": {
      "filePath": "_public/auth/telegram-callback.tsx",
      "parent": "/_public"
    },
    "/_authenticated/cities/": {
      "filePath": "_authenticated/cities/index.tsx",
      "parent": "/_authenticated/cities"
    },
    "/_authenticated/coin-transactions/": {
      "filePath": "_authenticated/coin-transactions/index.tsx",
      "parent": "/_authenticated/coin-transactions"
    },
    "/_authenticated/crm/": {
      "filePath": "_authenticated/crm/index.tsx",
      "parent": "/_authenticated/crm"
    },
    "/_authenticated/event-categories/": {
      "filePath": "_authenticated/event-categories/index.tsx",
      "parent": "/_authenticated/event-categories"
    },
    "/_authenticated/events/": {
      "filePath": "_authenticated/events/index.tsx",
      "parent": "/_authenticated/events"
    },
    "/_authenticated/extractor-config/": {
      "filePath": "_authenticated/extractor-config/index.tsx",
      "parent": "/_authenticated/extractor-config"
    },
    "/_authenticated/import-queue/": {
      "filePath": "_authenticated/import-queue/index.tsx",
      "parent": "/_authenticated/import-queue"
    },
    "/_authenticated/meeting-templates/": {
      "filePath": "_authenticated/meeting-templates/index.tsx",
      "parent": "/_authenticated/meeting-templates"
    },
    "/_authenticated/news/": {
      "filePath": "_authenticated/news/index.tsx",
      "parent": "/_authenticated/news"
    },
    "/_authenticated/organizer-blocks/": {
      "filePath": "_authenticated/organizer-blocks/index.tsx",
      "parent": "/_authenticated/organizer-blocks"
    },
    "/_authenticated/payment-providers/": {
      "filePath": "_authenticated/payment-providers/index.tsx",
      "parent": "/_authenticated/payment-providers"
    },
    "/_authenticated/place-categories/": {
      "filePath": "_authenticated/place-categories/index.tsx",
      "parent": "/_authenticated/place-categories"
    },
    "/_authenticated/places/": {
      "filePath": "_authenticated/places/index.tsx",
      "parent": "/_authenticated/places"
    },
    "/_authenticated/promotion-tasks/": {
      "filePath": "_authenticated/promotion-tasks/index.tsx",
      "parent": "/_authenticated/promotion-tasks"
    },
    "/_authenticated/service-categories/": {
      "filePath": "_authenticated/service-categories/index.tsx",
      "parent": "/_authenticated/service-categories"
    },
    "/_authenticated/services/": {
      "filePath": "_authenticated/services/index.tsx",
      "parent": "/_authenticated/services"
    },
    "/_authenticated/source-channels/": {
      "filePath": "_authenticated/source-channels/index.tsx",
      "parent": "/_authenticated/source-channels"
    },
    "/_authenticated/users/": {
      "filePath": "_authenticated/users/index.tsx",
      "parent": "/_authenticated/users"
    },
    "/_authenticated/users/fakes/$fakeId": {
      "filePath": "_authenticated/users/fakes/$fakeId.tsx",
      "parent": "/_authenticated/users"
    },
    "/_authenticated/users/fakes/new": {
      "filePath": "_authenticated/users/fakes/new.tsx",
      "parent": "/_authenticated/users"
    },
    "/_authenticated/users/fakes/": {
      "filePath": "_authenticated/users/fakes/index.tsx",
      "parent": "/_authenticated/users"
    }
  }
}
ROUTE_MANIFEST_END */
